import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { Grid } from "@elliemae/ds-grid";
import { DSHeader } from "@elliemae/ds-header";
import { Controller } from "react-hook-form";
import { Address } from "./address";
import { BorrowerDetails } from "./borrowerDetails";
import { GovernmentFees } from "./governmentFees";
import { Checkbox } from "../generic/checkbox";
import { Combobox } from "../generic/combobox";
import { Date } from "../generic/date";
import { OtherRealEstateOwned } from "./otherRealEstateOwned";
import { Textbox } from "../generic/textbox";
import { DefaultAndBankruptcy } from "./defaultAndBankruptcy";
import { PropertyReadOnly } from "./propertyreadonly";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
const Fieldgroup = ({
  schemaForm,
  rules,
  name,
  fields,
  visible,
  visibleCheck,
  disableCheck,
  preview,
  rest
}) => {
  const fieldComponentMap = {
    textbox: Textbox,
    combobox: Combobox,
    checkbox: Checkbox,
    date: Date,
    defaultandbankruptcy: DefaultAndBankruptcy
  };
  const { isVisible, isDisabled } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled: false,
    visibleCheck,
    disableCheck,
    preview
  });
  const renderField = (field) => {
    const {
      type,
      ui,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      component_id,
      id,
      label,
      required,
      helptext,
      options,
      selectMultiple
    } = field;
    const modelPath = field?.encompass_ids?.[0]?.modelPath;
    const key = [
      "Notice of Default (NOD)",
      "Bankruptcy",
      "NOD Type",
      "Bankruptcy Type"
    ].includes(component_id) ? "defaultandbankruptcy" : type === "enum" ? "combobox" : type === "boolean" ? "checkbox" : type === "string" && ui.widget === "datepicker" ? "date" : "textbox";
    const Component = key ? fieldComponentMap[key] : null;
    if (!Component) return null;
    return /* @__PURE__ */ jsx(
      Controller,
      {
        name: modelPath,
        render: ({ field: renderedField }) => /* @__PURE__ */ jsx(
          Component,
          {
            renderedField,
            schemaForm,
            rules: null,
            id,
            name: component_id,
            label,
            required,
            pathValue: modelPath,
            feedbackMessage: helptext,
            type,
            ui,
            options,
            isMulti: selectMultiple,
            visible: true,
            disabled: false,
            visibleCheck: null,
            disableCheck: null,
            preview,
            rest
          }
        )
      }
    );
  };
  const customComponentConfig = {
    "Other Real Estate Owned": /* @__PURE__ */ jsx(
      OtherRealEstateOwned,
      {
        schemaForm,
        fields,
        preview,
        rest
      }
    ),
    "Borrower Details": /* @__PURE__ */ jsx(
      BorrowerDetails,
      {
        schemaForm,
        fields,
        preview,
        rest
      }
    ),
    "Government Fees": /* @__PURE__ */ jsx(
      GovernmentFees,
      {
        schemaForm,
        fields,
        preview,
        rest
      }
    ),
    Geocodes: /* @__PURE__ */ jsx(
      PropertyReadOnly,
      {
        schemaForm,
        rules,
        preview,
        visible: true,
        visibleCheck: void 0
      }
    ),
    Address: preview ? void 0 : /* @__PURE__ */ jsx(Address, { schemaForm, fields, rest })
  };
  return customComponentConfig[name] ?? (isVisible && /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(Grid, { span: 12, children: /* @__PURE__ */ jsx(
      DSHeader,
      {
        text: name,
        fontSize: 12,
        fontWeight: "bold",
        lineHeight: 1,
        style: { marginTop: "16px" },
        color: void 0,
        fontFamily: void 0,
        height: void 0,
        level: void 0,
        width: void 0
      }
    ) }),
    fields.map(renderField)
  ] }));
};
export {
  Fieldgroup
};
